import { render, staticRenderFns } from "./ContentBlacklistCrew.vue?vue&type=template&id=065b6ab0&scoped=true"
import script from "./ContentBlacklistCrew.vue?vue&type=script&lang=js"
export * from "./ContentBlacklistCrew.vue?vue&type=script&lang=js"
import style0 from "./ContentBlacklistCrew.vue?vue&type=style&index=0&id=065b6ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b6ab0",
  null
  
)

export default component.exports